// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"_variables__pc_only___1R_L2","sp_only":"_variables__sp_only___1xzIk"};